function clickOutsideHandler({ eventTarget, elementArray, toggleCallback }) {
  // check if the click event.target does not contain either of the above elements passed via the array
  if (elementArray.every((el) => !el?.contains(eventTarget))) {
    toggleCallback();
  }
}

export default clickOutsideHandler;
